import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { recaptchaKey: String }

  submit(event) {
    event.preventDefault(); // Prevent the default form submission
    console.log("Form submission intercepted by Stimulus controller.");

    grecaptcha.ready(() => {
      console.log("reCAPTCHA is ready.");
      grecaptcha.execute(this.recaptchaKeyValue, {action: 'signup'}).then((token) => {
        console.log("reCAPTCHA token received:", token);

        // Add the token to the form
        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'g-recaptcha-response';
        tokenInput.value = token;
        this.formTarget.appendChild(tokenInput);

        // Submit the form programmatically
        console.log("Submitting form with reCAPTCHA token.");
        this.formTarget.submit();
      }).catch(error => {
        console.error("reCAPTCHA execution error:", error);
      });
    });
  }

  connect() {
    console.log("New user form controller connected.");
  }
}